<template>

	<div class="gray-bg" style="min-height: 100vh">

		<div class="middle-box text-center loginscreen   animated fadeInDown">
      <div>

        <div>
          <a target="_blank" href="https://www.snatchpark.com/parkbills/">
            <img src="/static/image/parkbills.png">
          </a>
          <img src="/static/image/park_bills_text_black.png">
        </div>
        
        <h3>ParkBills - Change Password</h3>

        <div v-show="verifyProgress">
          <br>
          {{ verifyProgress }}
          <br>
        </div>

        <div v-show="verifyError">
          <br>
          {{ verifyError }}
          <br>
        </div>
        
        <div v-show="!verifyProgress && !verifyError" class="m-t" role="form" action="login.html">
					
					<div class="form-group">
						<input v-model="email" type="text" class="form-control" required="" disabled readonly>
					</div>

          <input type="text" v-model="oldPassword" style="display:none"/>
          <input type="text" v-model="email" style="display:none"/>

					<div class="form-group">
						<input v-model="password" type="password" class="form-control" placeholder="Password" required="">
					</div>
					
					<div class="form-group">
						<input v-model="password_confirm" type="password" class="form-control" placeholder="Confirm Password" required="">
					</div>

          <label class="error form-control-feedback" >{{ error }} </label>
					
					<button type="submit" class="btn btn-primary block full-width m-b" @click.prevent="handleSubmit">
						Change Password
					</button>

<!--
          <p class="text-muted text-center"><small>Already have an account?</small></p>
          <a class="btn btn-sm btn-white btn-block" v-bind:href="helper.WEB_URL + '/login'">Login</a>
          <a class="btn btn-sm btn-white btn-block m-t" v-bind:href="helper.WEB_URL + '/register'">Register</a>
-->
        </div>
				
				<p class="m-t">
					<small><strong>Copyright</strong> PARKAIDE &copy; 2018</small>
				</p>

      </div>
    </div>
    
  </div>

</template>

<script>
import helper from "@/components/Utility/Helper"

export default {
  name: "PageChangePassword",
  data(){
    return {
      helper : helper,
      error : "",
      verifyProgress : "Verifying Account...",
      verifyError: "",

      email: '',
      oldPassword: '',
      password: '',
      password_confirm: '',
    }
  },
  mounted() {
    // /// TODO testing
    // this.email = 'kahwei.chuah+parker1@july.technology'
    // this.jwt = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6MTg3NywiaWF0IjoxNTU5NjE5Njc1LCJleHAiOjE1NTk3MDYwNzV9.MpuvMY8X6a4uA2ZtkpRpCXg-PSRcMrIJI34KOX2f_XQ';
    // this.oldPassword = 6;
    // this.verifyProgress = '';
    // return;

    if(window.location.href.includes('localhost')) {
      document.title = 'Localhost';
    } else if(window.location.href.includes('parkbills.parkaidemobile.com')) {
      document.title = 'ParkBills Dev';
    } else if(window.location.href.includes('devpbills.parkaidemobile.com')) {
      document.title = 'ParkBills Dev';
    }

    if(!this.$route.query.email || !this.$route.query.jwt) {
      helper.redirect(helper.WEB_URL + '/login');
      return;
    }

    this.email = this.$route.query.email;
    this.jwt = this.$route.query.jwt;

    this.handleRedirect();
  },
  methods : {
    handleRedirect() {
      this.$http
        .post(helper.API_URL + '/api2/auth2/web/verify/' + this.jwt, {
          email: this.email,
        })
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.oldPassword = response.data.password;
          this.verifyProgress = '';
        })
        .catch((error) => {
          this.verifyError = 'Problem verifying account. ' + this.parseLoginError(error);
          this.verifyProgress = '';
        });
    },
    handleSubmit(e){
      if(!this.password) {
        this.error = 'Password cannot be empty';
        return;
      }
      if(this.password !== this.password_confirm) {
        this.error = 'Password not match';
        return;
      }

      let header = {};
      header['x-access-token'] = this.jwt;
      let config = {};
      config['headers'] = header;
      
      this.$http
        .post(helper.API_URL + '/api2/auth2/web/reset', 
        {
          email: this.email,
          password: this.oldPassword,
          newpassword: this.password,
        },
        config)
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          localStorage.removeItem('user');
          localStorage.removeItem('meRoles');
          localStorage.removeItem('selectedRoleID');
          localStorage.removeItem('selectedCustomerID');
          localStorage.removeItem('selectedOperatorID');
          localStorage.removeItem('salt');
          // /// TODO testing
          // helper.redirect(helper.WEB_URL + '/verify');
          // return;
          helper.redirect(helper.WEB_URL + '/login');
        })
        .catch((error) => {
          this.error = 'Problem resetting password. ' + this.parseLoginError(error);
        });
    },
    parseLoginError(error) {
      if(error) {
        if(error.response) {
          if(error.response.data) {
            if(error.response.data.message) {
              return error.response.data.message;
            }

            if(typeof a_string === 'string') {
              return error.response.data;
            }
          }

          if(typeof a_string === 'string') {
            return error.response;
          }
        }
      }

      return 'Please try again.'
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Page/User/PageChangePassword.vue